import { RendererProvider } from '@atlassiansox/bxp-content-framework';
import { createGlobalStyle } from 'styled-components';
import React, { useEffect } from 'react';
import { useAnalytics, PlaceholderContext, HeaderFooterContextProvider } from '../../components';
import { renderViewModels, renderViewModel } from '../../render-view-model';
import { getColorsFromBackgroundField, generateFieldsStyles, isBackgroundFieldArray } from '../../styles';
export default function Page({ model }) {
    const { sendPageEvent } = useAnalytics();
    const { title, route, variant, sections = [], background, pageBackground, cookieBanner } = model.content;
    useEffect(() => {
        sendPageEvent('', {
            path: route.content.path,
            title,
            variant
        });
    }, [route.content.path, sendPageEvent]);
    const colors = getColorsFromBackgroundField(background);
    return (React.createElement(RendererProvider, { renderer: renderViewModel },
        React.createElement(GlobalStyle, { background: colors.background, pageBackground: isBackgroundFieldArray(pageBackground) ? pageBackground : undefined, color: colors.color, linkColor: colors.linkColor, linkHoverColor: colors.linkHoverColor }),
        React.createElement(HeaderFooterContextProvider, null,
            React.createElement(PlaceholderContext.Provider, { value: "page" },
                renderViewModels(sections),
                cookieBanner && renderViewModel(cookieBanner)))));
}
const GlobalStyle = createGlobalStyle `
  body {
    ${({ background }) => background ? `background: ${background};` : ''}           
      ${({ color }) => (color ? `color: ${color};` : '')}           
      ${({ linkColor }) => linkColor && `a { color: ${linkColor}; }`}
      ${({ linkHoverColor }) => linkHoverColor && `a:hover { color: ${linkHoverColor}; }`}

    ${({ pageBackground }) => pageBackground ? generateFieldsStyles(pageBackground) : ''}           
        }
`;
//# sourceMappingURL=Page.js.map